import React, { useState } from 'react';
import Layout from '../components/Layout';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is an RDP server?',
      answer: 'An RDP (Remote Desktop Protocol) server allows you to access and control a remote computer from anywhere in the world. Our RDP servers are high-performance virtual machines perfect for hosting, development, and various computing tasks.'
    },
    {
      question: 'How do I purchase an RDP server?',
      answer: 'Simply select a plan from our pricing page, choose your preferred location (USA or Netherlands), configure the operating system and duration, and complete the purchase using your account balance.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept cryptocurrency payments through OxaPay. You can top up your account balance using various cryptocurrencies, and then use that balance to purchase RDP servers.'
    },
    {
      question: 'Can I upgrade or downgrade my server?',
      answer: 'Yes, you can upgrade your server at any time through the server management page. The unused value from your current plan will be credited towards the upgrade cost.'
    },
    {
      question: 'How do I extend my server?',
      answer: 'You can extend your server from the server management page. Select the number of days you want to extend, and the cost will be deducted from your account balance.'
    },
    {
      question: 'What happens if my server expires?',
      answer: 'If you have auto-renewal enabled and sufficient balance, your server will automatically renew 30 days before expiration. Otherwise, the server will expire and you will need to purchase a new one.'
    },
    {
      question: 'Can I reinstall the operating system?',
      answer: 'Yes, you can reinstall your server with a different operating system from the server management page. Note that all data on the server will be lost during reinstallation.'
    },
    {
      question: 'What locations are available?',
      answer: 'We currently offer servers in two locations: USA and Netherlands. You can choose your preferred location when ordering a new server.'
    },
    {
      question: 'How do I reset my server password?',
      answer: 'You can reset your server password from the server management page. Click on "Change Password" and enter your new password.'
    },
    {
      question: 'What support do you offer?',
      answer: 'We offer support through our support ticket system and Telegram. Our team is available to help you with any issues or questions you may have.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="space-y-2 reveal reveal-up">
          <h1 className="text-3xl sm:text-4xl font-light text-white reveal reveal-up delay-1">
            Frequently Asked Questions
          </h1>
          <p className="text-sm text-blue-100/70 reveal reveal-up delay-2">
            Quick answers about ordering, payments, upgrades, and managing your RDP.
          </p>
        </div>

        <div className="rdp-card bg-[#212A5533] border border-[#B8B8B847] p-4 sm:p-5 space-y-3 reveal reveal-up delay-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-[#FFFFFF14] rounded-2xl border border-[#EBEBEB1C] overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 sm:px-6 py-4 flex items-center justify-between text-left transition-colors hover:bg-white/5"
              >
                <h3 className="text-base sm:text-lg font-medium text-white pr-4">{faq.question}</h3>
                {openIndex === index ? (
                  <FiChevronUp className="text-[#4F6BFF] flex-shrink-0" size={20} />
                ) : (
                  <FiChevronDown className="text-white/50 flex-shrink-0" size={20} />
                )}
              </button>
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-5">
                  <p className="text-sm sm:text-base text-blue-50/80 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default FAQ;
